module.exports = __webpack_public_path__ + "static/media/marksman-logo.5db5d7f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/marksman-logo.png
// module id = 382
// module chunks = 0